exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-24253cf6]{height:calc(100vh - 100px);margin:0 0 0 20px}.container .box-card[data-v-24253cf6]{height:100%;padding:20px 0 10px}.container .box-card[data-v-24253cf6]  .el-card__body{height:calc(100% - 94px)}.container .box-card[data-v-24253cf6]  .el-card__body .content{height:calc(100% - 30px);overflow-y:auto;scroll-behavior:smooth}.container .box-card[data-v-24253cf6]  .el-card__body .footer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:10px}", ""]);

// exports
